const saveMatchNotes = (matchId, newNotes, setData, saveResults) => {
    setData((prev) => {
      if (!prev) return prev;
  
      const newResults = prev.results.map((result) => {
        const updatedMatches = result.Matches.map((matchObj) => {
          const key = Object.keys(matchObj)[0];
          const match = matchObj[key];
  
          if (result.id !== matchId) return matchObj;
  
          return {
            [key]: {
              ...match,
              Notes: newNotes,
            },
          };
        });
  
        return { ...result, Matches: updatedMatches };
      });
  
      saveResults(prev.resultsID, newResults);
      return { ...prev, results: newResults };
    });
  };
  
  export default saveMatchNotes; // ✅ THIS LINE IS MISSING
  